import { render, staticRenderFns } from "./BookingThanks.vue?vue&type=template&id=4f27c448"
import script from "./BookingThanks.vue?vue&type=script&lang=js"
export * from "./BookingThanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports